export default {
  Payments: {
    CardPanMask: 'شماره کارت',
    Wallet: {
      Dollar: 'دلاری',
      Toman: 'تومانی',
      Amount: 'موجودی کیف پول',
    },
    User_Wallet: {
      Dollor: 'موجودی دلاری کاربران',
      Pending: 'موجودی در انتظار تایید کاربران',
      Amount: ' موجودی کیف پول کاربران',
    },
    Check: 'استعلام مجدد',
    Enter_confirm_payment_code: 'کد تایید تراکنش را وارد کنید',
    Gate: {
      Label: 'برچسب درگاه',
      Setting: {
        DailyCharge: 'شارژ روزانه',
        MaxPaymentAmount: 'حداکثر مبلغ پرداخت',
        DailyChargeUsed: 'شارژ استفاده شده روز',
        LastDailyChargeAt: 'آخرین شارژ روز',
      },
    },
    Status: {
      UnSuccess: 'ناموفق',
      Success: 'موفق',
      WaitForSuccess: 'منتظر تایید',
      Expire: 'منقضی شده',
      WrongPrice: 'عدم تطابق مبلغ',
    },
    SumAmounts: 'جمع کل مبلغ تراکنش‌ها',
    SumDiscounts: 'جمع کل مبلغ تخفیف‌ها',
    ConfirmPayment: 'تایید تراکنش',
    SumSuccess: 'مجموع کل تراکنش موفق',
    SumSuccessDollar: 'مجموع تراکنش ارزی موفق',
    SumFromGate: 'مجموع تراکنش های درگاه ها',
    CheckPayment: {
      Description: 'آیا می‌خواهید مبلغ این تراکنش به کیف پول کاربر اضافه شود؟',
      AddToWallet: 'افزودن مبلغ تراکنش به کیف پول',
    },
    Receipts: {
      Title: 'رسید',
      Receipts: 'رسیدها',
      Dashboard: {
        Title: 'لیست رسید های که نیاز به بررسی دارند',
        NotFound: ' رسید بررسی نشده ای وجود ندارد ',
        Show: 'مشاهده رسید',
      },
      Id: 'شماره رسید',
      PaymentNumber: 'شماره پرداخت',
      CardNumber: 'شماره کارت',
      DestinationCardNumber: 'شماره کارت مقصد',
      DestinationCardOwner: 'صاحب حساب مقصد',
      Status: 'وضعیت',
      ApprovedAt: 'تاریخ تایید',
      ApprovedBy: 'تایید شده توسط',
      StatusLabel: {
        New: 'جدید',
        Accepted: 'تایید شده',
        Rejected: 'رد شده',
      },
      Actions: {
        Detail: 'جزئیات',
      },
      ModalDetail: {
        Title: 'نمایش جزییات رسید',
      },
      ConfirmModal: {
        Accept: 'آیا از تایید این رسید مطمئن هستید؟',
        Reject: 'آیا از رد کردن این رسید مطمئن هستید؟',
      },
    },
  },
}
